import React from 'react';

import MessagePanel from '../../common/components/MessagePanel/MessagePanel';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';

function TokenInReviewScreen(): JSX.Element {
  return (
    <MessagePanel
      // @ts-ignore
      topIcon={null}
      title="screens.tokenInReview.title"
      description="screens.tokenInReview.description"
      showLoading
      showSupportLink
    />
  );
}
export default withRouteAnalytics(TokenInReviewScreen, Screens.TOKEN_IN_REVIEW);
